import { render, staticRenderFns } from "./TeacherDetails.vue?vue&type=template&id=351f52d6&scoped=true"
import script from "./TeacherDetails.vue?vue&type=script&lang=js"
export * from "./TeacherDetails.vue?vue&type=script&lang=js"
import style0 from "./TeacherDetails.vue?vue&type=style&index=0&id=351f52d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f52d6",
  null
  
)

export default component.exports